const state = {
    therapists: null
};
const actions = {
    setTherapists({ commit }, payload) {
        commit('updateTherapistsList', payload);
    }
};

const mutations = {
    updateTherapistsList(state, payload) {
        state.therapists = payload;

    }
};

export const therapistListModule = {
    namespaced: true,
    state,
    actions,
    mutations
};
